import styled from 'styled-components';
import { Menu, MenuButton, MenuItem } from '@szhsin/react-menu';

export const StyledSideBar = styled.div`
  background: #101010;
  padding: 20px 0 6px;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: ${({ $sideBar }) => ($sideBar ? '350px' : '60px')};
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--white);
  z-index: 70;
  flex-shrink: 0;
  transition: 0.3s all ease-in-out;
  border-right: 1px solid rgba(255, 255, 255, 0.2);

  @media (min-width: 1200px) {
    width: ${({ $sideBar }) => ($sideBar ? '300px' : '60px')};
  }
  @media (min-width: 1400px) {
    width: ${({ $sideBar }) => ($sideBar ? '350px' : '60px')};
  }

  @media (max-width: 1199px) {
    width: ${({ $sideBar }) => ($sideBar ? '0' : '350px')};
    left: ${({ $sideBar }) => ($sideBar ? '-500px' : '0')};
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  }

  .scroll-area {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: calc(100vh - 150px);

    &::-webkit-scrollbar {
      width: 0;
    }

    .sidebar-active & {
      overflow: auto;
    }

    @media (max-width: 1199px) {
      overflow: auto;
    }
  }

  .nav-wrapper {
    width: 100%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .nav-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      padding: 0 15px 10px;

      .icon-wrap {
        display: flex;
        align-items: center;
        gap: 18px;
      }

      .menu-btn,
      .search-btn {
        cursor: pointer;
      }
      .search-btn {
        display: none;
      }

      .menu-btn {
        position: relative;
        width: ${({ $sideBar }) => ($sideBar ? '28px' : '36px')};
        transition: all 0.3s ease-in-out;
        right: ${({ $sideBar }) => ($sideBar ? '0' : '25px')};
        color: ${({ $sideBar }) => ($sideBar ? '#fff' : '#fff')};
        transform: ${({ $sideBar }) => ($sideBar ? 'scaleX(1)' : 'scaleX(-1)')};
        background: ${({ $sideBar }) => ($sideBar ? 'transparent' : '#1A1A1A')};
        padding: ${({ $sideBar }) => ($sideBar ? '0' : '5px')};
        border-radius: 5px 0 0 5px;

        @media (max-width: 1199px) {
          width: ${({ $sideBar }) => ($sideBar ? '36px' : '28px')};
          top: ${({ $sideBar }) => ($sideBar ? '-7px' : '0')};
          right: ${({ $sideBar }) => ($sideBar ? '-340px' : '0')};
          /* color: ${({ $sideBar }) => ($sideBar ? '#fff' : '#fff')}; */
          padding: ${({ $sideBar }) => ($sideBar ? '5px' : '0')};
          transform: ${({ $sideBar }) => ($sideBar ? 'scaleX(-1)' : 'scaleX(1)')};
          background: ${({ $sideBar }) => ($sideBar ? '#1a1a1a' : 'transparent')};
          border-radius: 5px;
        }
      }
    }

    .logo {
      width: 60px;
      flex-shrink: 0;
      transition: all ease-in-out 0.4s;

      @media (max-width: 1199px) {
        width: 150px;
      }

      .sidebar-active & {
        width: 150px;
      }

      a {
        display: block;
      }
      img {
        max-width: 100%;
        height: auto;
        transition: all ease-in-out 0.4s;

        &.logo-lg {
          display: none;

          .sidebar-active & {
            display: block;
          }

          @media (max-width: 1199px) {
            display: block;
          }
        }
        &.logo-sm {
          display: block;

          .sidebar-active & {
            display: none;
          }

          @media (max-width: 1199px) {
            display: none;
          }
        }
      }
    }

    .nav-links {
      padding: 15px 15px;
      font-size: 16px;
      line-height: 20px;

      &.nav2 {
        visibility: hidden;

        .sidebar-active & {
          visibility: visible;
        }

        @media (max-width: 1199px) {
          visibility: visible;
        }
      }

      li {
        position: relative;
        width: 100%;
        text-align: left;

        .shortkey {
          display: flex;
          align-items: center;
          justify-content: end;
          flex-grow: 1;
          gap: 10px;

          span {
            font-size: 12px;
            color: var(--white);
            font-weight: 500;
            text-transform: uppercase;
            border: 1px solid var(--white);
            border-radius: 8px;
            padding: 2px 10px;
          }
        }

        a,
        button {
          width: 100%;
          display: flex;
          align-items: center;
          gap: 12px;
          overflow: hidden;
          transition: all 0.3s ease-in-out;
          padding: 7px 5px;

          &:hover,
          &.active {
            transition: all 0.3s ease-in-out;
            background: #00dc49;
            border-radius: 8px;
            padding: 7px 5px;
          }

          .label {
            display: block;
            color: var(--white);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .icon {
          width: 28px;
          height: 23px;
          flex-shrink: 0;
          color: var(--white);
        }
      }

      .btn-logout {
        font-size: 16px;
        line-height: 20px;
      }
    }

    .chat-history {
      flex-grow: 1;
      overflow-y: auto;
      padding: 15px;
      border-width: 1px 0;
      border-style: solid;
      border-color: rgba(255, 255, 255, 0.2);
      visibility: hidden;

      .sidebar-active & {
        visibility: visible;
      }

      @media (max-width: 1199px) {
        visibility: visible;
      }

      .head {
        display: flex;
        align-items: start;
        justify-content: space-between;
        gap: 5px;
      }
    }

    .subheading {
      display: block;
      font-size: 16px;
      line-height: 19px;
      font-weight: 500;
      color: var(--white);
      margin-bottom: 12px;
    }
    .subheading2 {
      display: block;
      font-size: 14px;
      line-height: 18px;
      font-weight: 500;
      color: #afafaf;
      margin-bottom: 10px;
    }
  }

  .profile-holder {
    cursor: pointer;
    position: relative;
    width: 100%;
    z-index: 3;
    overflow: hidden;
    padding: 15px 10px 10px;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    gap: 14px;
    flex-shrink: 0;

    .sidebar-active & {
      padding: 15px 15px 10px;
    }

    .icon-arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: -15px;
      font-size: 20px;
      line-height: 0;
      visibility: hidden;
      opacity: 0;
      transition: all ease-in-out 0.4s;

      .sidebar-active & {
        right: 15px;
        opacity: 1;
        visibility: visible;
        transition-delay: 0.4s;
      }

      @media (max-width: 1199px) {
        right: 15px;
        opacity: 1;
        visibility: visible;
        transition-delay: 0.4s;
      }
    }

    .profile-img {
      width: 40px;
      height: 40px;
      border-radius: 50px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      position: relative;
      transition: all ease-in-out 0.4s;
      background: #00dc49;

      .sidebar-active & {
        width: 50px;
        height: 50px;
      }

      @media (max-width: 1199px) {
        width: 50px;
        height: 50px;
      }

      .text {
        display: block;
        font-size: 23px;
        line-height: 26px;
        text-transform: uppercase;
        font-weight: 600;
        color: var(--white);
      }

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .profile-info {
      flex-grow: 1;
      color: var(--white);
      text-transform: capitalize;
      visibility: hidden;

      .sidebar-active & {
        visibility: visible;
      }

      @media (max-width: 1199px) {
        visibility: visible;
      }

      .name {
        display: block;
        font-size: 18px;
        line-height: 22px;
        font-weight: 600;
        margin-bottom: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .text {
        display: block;
        font-size: 16px;
        line-height: 20px;
        font-weight: 300;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .btn-holder {
    width: 100%;
    padding: 0 15px;
  }
`;

export const MenuBtn = styled(MenuButton)`
  position: relative;
  font-size: 14px;
  line-height: 20px;
  color: var(--black);
  border-radius: 5px;
  padding: 3px 10px;
  text-align: center;
  font-weight: 600;
  background: var(--white);
`;
export const ReponseMenu = styled(Menu)`
  box-shadow:
    0 0 7px rgba(0, 0, 0, 0.133),
    0 0 2px rgba(0, 0, 0, 0.1);

  ul {
    width: 100px;
    padding: 5px;
    border-radius: 5px;
    max-height: 250px;
    overflow-y: auto;

    .text {
      font-size: 14px;
      line-height: 17px;
    }
  }
  &.szh-menu-container {
    left: 0 !important;
    right: 0 !important;
  }
  .szh-menu {
    left: auto !important;
    right: 16px !important;
    z-index: 10 !important;
  }
`;
export const StyleItem = styled(MenuItem)`
  display: block;
  padding: 3px 6px;
  margin: 0 0 3px;
  border-radius: 3px;

  &.active,
  &:hover {
    background: var(--gray-100);
  }

  &:last-child {
    margin: 0;
  }
`;
